var map = {
	"./01 Bahjat Alqamar (Moon Elation)-Master.mp3": 9454,
	"./02 Ahlamun wa Amani (Hopes And Dreams)-Master.mp3": 1843,
	"./03 Mughamara (Adventure)-Master.mp3": 2831,
	"./04 Nuzha Fi Assooq (Market Stroll)-Master.mp3": 9582,
	"./05 Mahboobati (My Beloved)-Master.mp3": 1321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4343;